import ApiService from '@/core/services/api.service'

//Action types
export const GET_EJECUTIVOSCORREDORES = "getEjecutivosCorredores";
export const GET_EJECUTIVOCORREDOR = "getEjecutivoCorredor";
export const CREATE_EJECUTIVOCORREDOR = "createEjecutivoCorredor";
export const UPDATE_EJECUTIVOCORREDOR = "updateEjecutivoCorredor";
export const DELETE_EJECUTIVOCORREDOR = "deleteEjecutivoCorredor";
export const DESACTIVAR_EJECUTIVOCORREDOR = "desactivarEjecutivoCorredor"

//Mutadores
export const SET_EJECUTIVOSCORREDORES = "setEjecutivoCorredor";
export const SET_EJECUTIVOCORREDOR = "setEjecutivoCorredor";
export const SET_ERROR = "setError"

const state = {
    error: null,
    ejecutivosCorredores: []
}

const actions = {
    [GET_EJECUTIVOSCORREDORES](context) {
        return new Promise((resolve) => {
            ApiService.setHeader();
            ApiService.get({ action: '/facturacioncomisionapi/api/EjecutivoCorredor/v1/EjecutivoCorredor' }, "")
                .then(({ data }) => {
                    context.commit(SET_EJECUTIVOSCORREDORES, data);
                    resolve(data)
                })
                .catch(({ response }) => {
                    //console.log(("error: " + response);
                    context.commit(SET_ERROR, "");
                })
        })
    },
    [GET_EJECUTIVOCORREDOR](context, ejecutivoCorredor) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.get({ action: `/facturacioncomisionapi/api/EjecutivoCorredor/v1/EjecutivoCorredor/${ejecutivoCorredor.rut}` }, ejecutivoCorredor)
                .then(({ data }) => {
                    context.commit(SET_EJECUTIVOCORREDOR, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    //console.log(('Hubo un problema al obtener al ejecutivoc corredor.');
                    context.commit(SET_ERROR, "");
                })
        })
    },
    [CREATE_EJECUTIVOCORREDOR](context, ejecutivoCorredor) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.post({ action: '/facturacioncomisionapi/api/EjecutivoCorredor/v1/EjecutivoCorredor' }, ejecutivoCorredor)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, {
                        error: ["No se pudo ingresar el registro"]
                    })
                    reject(response);
                });
        })
    },
    [UPDATE_EJECUTIVOCORREDOR](context, ejecutivoCorredor){
        return new Promise((resolve, reject) => {
            ApiService.put({action: '/facturacioncomisionapi/api/EjecutivoCorredor/v1/EjecutivoCorredor'}, ejecutivoCorredor)
                .then(({data}) => {
                    resolve(data)
                })
                .catch(({response}) => {
                    reject(response)
                })
        })
    },
    [DELETE_EJECUTIVOCORREDOR](contexr, ejecutivoCorredor){
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.delete({action: `/facturacioncomisionapi/api/EjecutivoCorredor/v1/EjecutivoCorredor/${ejecutivoCorredor.rut}`}, ejecutivoCorredor)
                .then(({data}) => {
                    resolve(data)
                })
                .catch(({response}) => {
                    reject(response)
                })
        })
    },
    [DESACTIVAR_EJECUTIVOCORREDOR](context, ejecutivoCorredor){
        return new Promise((resolve, reject) => {
            ApiService.put({action: '/facturacioncomisionapi/api/EjecutivoCorredor/v1/DesactivarEjecutivoCorredor'}, ejecutivoCorredor)
            .then(({ data }) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            })
        })
    }
}

const mutations={
    [SET_ERROR](state, error){
        state.error = error
    },
    [SET_EJECUTIVOSCORREDORES](state, ejecutivosCorredores){
        state.error = {};
        state.ejecutivosCorredores = ejecutivosCorredores;
    }
}

export default{
    state,
    actions,
    mutations
}